import { departmentSchema } from 'components/Department/validation';
import DrawerActions from 'components/DrawerActions/DrawerActions';
import { TextField } from 'components/TextField';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import { DepartmentPayload } from 'services/api';

const CHARACTER_LIMIT = 30;

type DepartmentPayloadType = {
  initialValues: DepartmentValuesType;
  handleSubmit: (
    values: DepartmentValuesType,
    actions: FormikHelpers<DepartmentValuesType>
  ) => void;
  actions: (props: FormikProps<DepartmentValuesType>) => JSX.Element;
};

export type DepartmentValuesType = DepartmentPayload & {
  reset?: boolean;
};

const DepartmentForm = ({
  initialValues,
  handleSubmit,
  actions
}: DepartmentPayloadType) => {
  return (
    <div style={{ paddingTop: 5 }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={departmentSchema}
      >
        {(props) => {
          const { values, setFieldValue } = props;
          return (
            <Form>
              <TextField
                id="name"
                name="name"
                label="Department Name*"
                onChange={(e) =>
                  setFieldValue(
                    'name',
                    e.target.value.slice(0, CHARACTER_LIMIT)
                  )
                }
                value={values.name}
                helperText={`${values.name.length}/${CHARACTER_LIMIT} characters`}
                fullWidth
                sx={{
                  '& .MuiFormHelperText-root': {
                    textAlign: 'right'
                  }
                }}
              />
              <DrawerActions>{actions(props)}</DrawerActions>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default DepartmentForm;
